import React from 'react';

type BlogPostTemplateProps = {
  genre: string;
  title: string;
  subtitle: string;
  children: React.ReactNode;
};

function BlogPostTemplate({ genre, title, subtitle, children }: BlogPostTemplateProps) {
  return (
    <article className="blog-post-template">
      <header className="blog-post-header">
        <p className="blog-genre">{genre}</p>
        <h1>{title}</h1>
        <p className="blog-subtitle">{subtitle}</p>
      </header>
      <div className="blog-post-content">{children}</div>
    </article>
  );
}

export default BlogPostTemplate;
